export const BusinessesAndOrganizations = [
  {
    url: "https://tomedes.gumlet.io/frontend/images/customer-logos/corporations/google-logo.svg",
  },
  {
    url: "https://tomedes.gumlet.io/frontend/images/customer-logos/corporations/volkswagen.svg",
  },
  {
    url: "https://tomedes.gumlet.io/frontend/images/customer-logos/corporations/dhl.svg",
  },
  {
    url: "https://tomedes.gumlet.io/frontend/images/customer-logos/corporations/hilton-logo.svg",
  },
  {
    url: "https://tomedes.gumlet.io/frontend/images/customer-logos/corporations/WarnerMusic.svg",
  },
  {
    url: "https://tomedes.gumlet.io/frontend/images/customer-logos/corporations/johnson-johnson.svg",
  },
  {
    url: "https://tomedes.gumlet.io/frontend/images/customer-logos/corporations/amazon-logo.svg",
  },
  {
    url: "https://tomedes.gumlet.io/frontend/images/customer-logos/corporations/medtronic.svg",
  },
  {
    url: "https://tomedes.gumlet.io/frontend/images/customer-logos/corporations/youtube.svg",
  },
  {
    url: "https://tomedes.gumlet.io/frontend/images/customer-logos/corporations/symantec.svg",
  },
  {
    url: "https://tomedes.gumlet.io/frontend/images/customer-logos/corporations/british-airways.svg",
  },
  {
    url: "https://tomedes.gumlet.io/frontend/images/customer-logos/corporations/straus.svg",
  },
  {
    url: "https://tomedes.gumlet.io/frontend/images/customer-logos/corporations/jcb.svg",
  },
  {
    url: "https://tomedes.gumlet.io/frontend/images/customer-logos/corporations/maersk-logo.svg ",
  },
  {
    url: "https://tomedes.gumlet.io/frontend/images/customer-logos/corporations/Coca-Cola-red.svg",
  },
  {
    url: "https://tomedes.gumlet.io/frontend/images/customer-logos/corporations/keller-williams.svg ",
  },
  {
    url: "https://tomedes.gumlet.io/frontend/images/customer-logos/corporations/exxon-mobil.svg ",
  },
  {
    url: "https://tomedes.gumlet.io/frontend/images/customer-logos/corporations/warner-bros.svg  ",
  },
  {
    url: "	https://tomedes.gumlet.io/frontend/images/customer-logos/corporations/bnp-paribas.svg",
  },
  {
    url: "https://tomedes.gumlet.io/frontend/images/customer-logos/corporations/nesic.png  ",
  },
  {
    url: "https://tomedes.gumlet.io/frontend/images/customer-logos/corporations/hitachi-logo.svg",
  },
  {
    url: "https://tomedes.gumlet.io/frontend/images/customer-logos/corporations/craneco-logo.svg ",
  },
  {
    url: "	https://tomedes.gumlet.io/frontend/images/customer-logos/corporations/sap.svg ",
  },
  {
    url: "https://tomedes.gumlet.io/frontend/images/customer-logos/corporations/mgm1.png ",
  },
  {
    url: "https://tomedes.gumlet.io/frontend/images/customer-logos/corporations/nvidia.PNG  ",
  },
  {
    url: "https://tomedes.gumlet.io/frontend/images/customer-logos/corporations/oracle-6.svg",
  },
  {
    url: " https://tomedes.gumlet.io/frontend/images/customer-logos/corporations/Canon.svg ",
  },
  {
    url: "https://tomedes.gumlet.io/frontend/images/customer-logos/corporations/stevemadden.svg",
  },
  {
    url: "https://tomedes.gumlet.io/frontend/images/customer-logos/corporations/kiwi.svg  ",
  },
  {
    url: "https://tomedes.gumlet.io/frontend/images/customer-logos/corporations/bbc_logo.svg ",
  },
  {
    url: "https://tomedes.gumlet.io/frontend/images/customer-logos/corporations/Decathlon_Logo.svg",
  },
  {
    url: "https://tomedes.gumlet.io/frontend/images/customer-logos/corporations/discovery-logo.svg ",
  },
  {
    url: "https://tomedes.gumlet.io/frontend/images/customer-logos/corporations/nestle_osem.webp ",
  },
  {
    url: "https://tomedes.gumlet.io/frontend/images/customer-logos/academy/tedx_en.svg",
  },
  { url: "https://tomedes.gumlet.io/frontend/images/academy/UN_en.svg " },
  {
    url: "	https://tomedes.gumlet.io/frontend/images/customer-logos/corporations/british-red-cross.svg",
  },
];

export const HighTechData = [
  {
    url: "https://tomedes.gumlet.io/frontend/images/customer-logos/corporations/youtube.svg",
  },
  {
    url: "https://tomedes.gumlet.io/frontend/images/customer-logos/hightech-internet/check-point.svg",
  },
  {
    url: "https://tomedes.gumlet.io/frontend/images/customer-logos/corporations/google-logo.svg",
  },
  {
    url: "	https://tomedes.gumlet.io/frontend/images/customer-logos/hightech-internet/yelp.svg",
  },
  {
    url: "https://tomedes.gumlet.io/frontend/images/customer-logos/corporations/amazon-logo.svg",
  },
  {
    url: "	https://tomedes.gumlet.io/frontend/images/customer-logos/hightech-internet/cellebrite-logo.svg",
  },
  {
    url: "https://tomedes.gumlet.io/frontend/images/customer-logos/hightech-internet/amdocs.svg",
  },
  {
    url: "https://tomedes.gumlet.io/frontend/images/customer-logos/hightech-internet/wix.svg",
  },
  {
    url: "	https://tomedes.gumlet.io/frontend/images/customer-logos/hightech-internet/3m.svg",
  },
  {
    url: "https://tomedes.gumlet.io/frontend/images/customer-logos/hightech-internet/hp.svg",
  },
  {
    url: "https://tomedes.gumlet.io/frontend/images/customer-logos/hightech-internet/spotify.svg",
  },
  {
    url: "	https://tomedes.gumlet.io/frontend/images/customer-logos/hightech-internet/verifone.svg",
  },
  {
    url: "https://tomedes.gumlet.io/frontend/images/customer-logos/hightech-internet/motorola.svg",
  },
  {
    url: "	https://tomedes.gumlet.io/frontend/images/customer-logos/corporations/symantec.svg",
  },
  {
    url: "https://tomedes.gumlet.io/frontend/images/customer-logos/hightech-internet/viber.svg",
  },
  {
    url: "	https://tomedes.gumlet.io/frontend/images/customer-logos/hightech-internet/broadcom_ltd_logo.svg",
  },
  {
    url: "https://tomedes.gumlet.io/frontend/images/customer-logos/hightech-internet/ms.svg",
  },
  {
    url: "	https://tomedes.gumlet.io/frontend/images/customer-logos/corporations/ahrefs.svg",
  },
];

export const LawAndFinanceData = [
  {
    url: "https://tomedes.gumlet.io/frontend/images/customer-logos/law-finance/credit-suisse-logo.svg",
  },
  {
    url: "	https://tomedes.gumlet.io/frontend/images/customer-logos/law-finance/hsbc.svg",
  },
  {
    url: "	https://tomedes.gumlet.io/frontend/images/customer-logos/law-finance/perkins-coie.svg",
  },
  {
    url: "https://tomedes.gumlet.io/frontend/images/customer-logos/law-finance/greenberg-traurig.svg",
  },
  {
    url: "	https://tomedes.gumlet.io/frontend/images/customer-logos/law-finance/moneygram-logo.svg",
  },
  {
    url: "	https://tomedes.gumlet.io/frontend/images/customer-logos/law-finance/howden.svg",
  },
  {
    url: "	https://tomedes.gumlet.io/frontend/images/customer-logos/law-finance/kpmg.svg",
  },
  {
    url: "	https://tomedes.gumlet.io/frontend/images/customer-logos/law-finance/krl.png",
  },
  {
    url: "https://tomedes.gumlet.io/frontend/images/customer-logos/law-finance/bloomberg.svg",
  },
  {
    url: "https://tomedes.gumlet.io/frontend/images/customer-logos/law-finance/ernst-youngsvg.svg",
  },
  {
    url: "	https://tomedes.gumlet.io/frontend/images/customer-logos/law-finance/rbc.svg",
  },
  {
    url: "https://tomedes.gumlet.io/frontend/images/customer-logos/law-finance/new_york_life_logo.svg",
  },
];

export const AcademyData = [
  {
    url: "https://tomedes.gumlet.io/frontend/images/customer-logos/academy/georgetown_university_logotype.svg",
  },
  {
    url: "https://tomedes.gumlet.io/frontend/images/customer-logos/academy/stanford_wordmark_(2012).svg",
  },
  {
    url: "	https://tomedes.gumlet.io/frontend/images/customer-logos/academy/university_of_london_logo.svg",
  },
  {
    url: "	https://tomedes.gumlet.io/frontend/images/customer-logos/academy/yale-signature-sprite.svg",
  },
  {
    url: "	https://tomedes.gumlet.io/frontend/images/customer-logos/academy/university_of_chicago_wordmark.svg",
  },
  {
    url: "https://tomedes.gumlet.io/frontend/images/customer-logos/academy/cornell_nniversity_logo.svg",
  },
  {
    url: "	https://tomedes.gumlet.io/frontend/images/customer-logos/academy/ucberkeley.svg",
  },
  {
    url: "	https://tomedes.gumlet.io/frontend/images/customer-logos/academy/university_of_minnesota_wordmark.png",
  },
  {
    url: "	https://tomedes.gumlet.io/frontend/images/customer-logos/academy/weizmann_institute_of_science_logo.svg",
  },
  {
    url: "	https://tomedes.gumlet.io/frontend/images/customer-logos/academy/university_of_arkansas_logo.svg",
  },
  {
    url: "	https://tomedes.gumlet.io/frontend/images/customer-logos/academy/uniofmanchesterlogo.svg",
  },
  {
    url: "https://tomedes.gumlet.io/frontend/images/customer-logos/academy/university_of_washington_seal.svg",
  },
  {
    url: "https://tomedes.gumlet.io/frontend/images/customer-logos/academy/university-of-colorado-springs.svg",
  },
  {
    url: "https://tomedes.gumlet.io/frontend/images/customer-logos/academy/unt.svg",
  },
  {
    url: "	https://tomedes.gumlet.io/frontend/images/customer-logos/academy/technion_en.svg",
  },
];

export const AppsData = [
  {
    url: "	https://tomedes.gumlet.io/frontend/images/customer-logos/apps/NVIDIA-TegraZone2.svg",
  },
  {
    url: "https://tomedes.gumlet.io/frontend/images/customer-logos/apps/snapchat-logo.svg",
  },
  {
    url: "https://tomedes.gumlet.io/frontend/images/customer-logos/apps/mixcloud.svg",
  },
  {
    url: "https://tomedes.gumlet.io/frontend/images/customer-logos/apps/zemingo.svg",
  },
  {
    url: "	https://tomedes.gumlet.io/frontend/images/customer-logos/apps/tiny-lab-box.png",
  },
  {
    url: "	https://tomedes.gumlet.io/frontend/images/customer-logos/apps/lupa.png",
  },
  {
    url: "https://tomedes.gumlet.io/frontend/images/customer-logos/apps/tabtale.png",
  },
  {
    url: "	https://tomedes.gumlet.io/frontend/images/customer-logos/apps/newton_by_cloudmagic_logo.png",
  },
  {
    url: "https://tomedes.gumlet.io/frontend/images/customer-logos/apps/mobisystems.svg",
  },
  {
    url: "https://tomedes.gumlet.io/frontend/images/customer-logos/apps/playscape.png",
  },
  {
    url: "	https://tomedes.gumlet.io/frontend/images/customer-logos/apps/deliveroo.svg",
  },
  {
    url: "https://tomedes.gumlet.io/frontend/images/customer-logos/apps/webpals.png",
  },
  {
    url: "https://tomedes.gumlet.io/frontend/images/customer-logos/apps/tonara.svg",
  },
  {
    url: "	https://tomedes.gumlet.io/frontend/images/customer-logos/apps/magoosh-logo.svg",
  },
  {
    url: " https://tomedes.gumlet.io/frontend/images/customer-logos/apps/cyberghost.png",
  },
  {
    url: " https://tomedes.gumlet.io/frontend/images/customer-logos/apps/umake.png",
  },
];
